import { Target } from "lucide-react";
import { useTranslation } from "react-i18next";

import type { HomeCardLayout } from "@/campaigns";
import type { Chase } from "@/campaigns/modules/chase/types";
import { topRung } from "@/campaigns/modules/chase/types";
import { CompactCampaignCard } from "@/components/campaign-card/campaign-card-compact";
import { formatPrizeTitle } from "@/utils/helpers";

/**
 * Home-feed card — a thin wrapper around the shared `CompactCampaignCard`. The hook is the
 * ladder's best prize (the cheapest rung), like every other card's "Top prize"; the cue under it
 * says what it takes: the spins that rung allows.
 */
export const ChaseHomeCard = ({
  chase,
  layout,
}: {
  chase: Chase;
  layout: HomeCardLayout;
}) => {
  const { t } = useTranslation();
  const top = topRung(chase);

  return (
    <CompactCampaignCard
      campaign={chase.campaign}
      typeLabel={t("chase.typeLabel", "Chase")}
      typeIcon={<Target />}
      hookValue={top ? formatPrizeTitle(top.prize.title, t) : null}
      hookLabel={t("campaign.topPrize", "Top prize")}
      hookIsCatalogItem={top?.prize.is_catalog_item}
      metaExtra={
        top
          ? t("chase.finishWithinShort", "Finish within {{count}} spins", {
              count: top.budget,
            })
          : undefined
      }
      layout={layout}
    />
  );
};
